import { StatusIncorporacaoCell } from './produtosDadosGerais/components/ProdutoIncorporacaoStatusBadge';
import type { CustomTableHeader } from '../../../../components/CustomTable';
import BolinhaTabelaStatus from '../../../../components/bolinhaTabelaStatus';

export type ProdutosTableRow = {
  id: string | number;
  status: boolean;
  tipoProduto: string;
  compBasico: boolean;
  compEspecializado: boolean;
  compEstrategico: boolean;
  produtoFarmaceutico: string;
  [key: string]: any;
};

export const valoresExibidosProdutos: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorTags: '',
  separadorComponente: '',
  separadorObservacoes: '',

  //Específicos
  tipoProduto: 'Tipo de Produto',
  produto: 'Produto',
  umidade: 'Umidade',
  oncologico: 'Oncológico',
  acondicionamento: 'Acondicionamento',
  biologico: 'Biológico',
  status: 'Status de Distribuição',
  tags: 'Tags',
  compBasico: 'Comp. Básico',
  compEspecializado: 'Comp. Especializado',
  compEstrategico: 'Comp. Estratégico',
  usoHospitalar: 'Uso Hospitalar?',
  farmaciaPopular: 'Disponível na Farm. Popular?',
  grupoEspecializado: 'Grupo Financiamento',
  statusRename: 'Status Rename',
  codigoAtc: 'ATC',
  rara: 'Doença Rara',
};

export const renderStatusDot = (value: unknown) => {
  const isActive = value === true || value === 'S';
  return <BolinhaTabelaStatus status={isActive ? 'S' : 'N'} />;
};

export const headersProdutos: CustomTableHeader<ProdutosTableRow>[] = [
  { text: '', width: 1, key: '', renderable: false },
  { text: 'ID', width: 4, key: 'id', fieldType: 'number' },
  {
    text: 'Status',
    width: 4,
    key: 'status',
    renderCell: (value) => renderStatusDot(value),
    fieldType: 'checkbox',
    filterDefaultValue: 'true',
  },
  { text: 'Tipo', width: 10, key: 'tipoProduto' },
  {
    text: 'Básico',
    width: 4,
    key: 'compBasico',
    renderCell: (value) => renderStatusDot(value),
    fieldType: 'checkbox',
  },
  {
    text: 'Especializado',
    width: 4,
    key: 'compEspecializado',
    renderCell: (value) => renderStatusDot(value),
    fieldType: 'checkbox',
  },
  {
    text: 'Estratégico',
    width: 4,
    key: 'compEstrategico',
    renderCell: (value) => renderStatusDot(value),
    fieldType: 'checkbox',
  },
  {
    text: 'Oncológico',
    width: 4,
    key: 'compOncologico',
    renderCell: (value) => renderStatusDot(value),
    fieldType: 'checkbox',
  },
  {
    text: 'Raras',
    width: 4,
    key: 'compRara',
    renderCell: (value) => renderStatusDot(value),
    fieldType: 'checkbox',
  },
  {
    text: 'Produto Farmarcêutico',
    width: 50,
    key: 'produtoFarmaceutico',
    fieldType: 'text',
  },
];

export const valoresExibidosIncorporacao: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorIncorporacao: '',
  separadorDocumento: '',
  separadorPactuacao: '',
  separadorDesincorporacao: '',
  separadorRelatorio: '',
  separadorAtualizacao: '',
  separadorObservacoes: '',

  //Específicos
  statusIncorporacao: 'Status da Incorporação',
  dataIncorporacao: 'Data da Incorporação',
  portariaIncorporacao: 'Portaria de Incorporação',
  linkPortariaIncorporacao: 'Link Portaria Incorp.',
  documentoTecnicoOrientador: 'Tipo de Doc. Orientador',
  dataDocumento: 'Data do Documento',
  documentoTecnicoOrientadorTitulo: 'Documento Orientador',
  documentoTecnicoOrientadorLink: 'Link do documento',
  dataDesincorporacao: 'Data de Desincorporação',
  portariaDesincorporacao: 'Portaria de Desincorporação',
  linkPortariaDesincorporacao: 'Link Portaria Desincorporação',
  relatorioRecomendacao: 'Relatório de Recomendação',
  dataRelatorio: 'Data do Relatório',
  linkRelatorioRecomendacao: 'Link do Relatório',
  statusAtualizacao: 'Status de Atualização da Incorporação',
  dataInicioAtualizacao: 'Data de Início da Atualização',
  dataAtualizacao: 'Data da Atualização',
  motivoAtualizacao: 'Motivo da Atualização',

  statusPactuacao: 'Status de Pactuação',
  ataPactuacao: 'Ata da Pactuação',
  dataPactuacao: 'Data da Pactuação',
  ataPactuacaoLink: 'Link da Ata de Pactuação',

  secaoRecomendacao: '',
  secaoIncorporacao: '',
  secaoDocumento: '',
  secaoPactuacao: '',
  secaoAtualizacao: '',
  secaoDesincorporacao: '',
};

export type ProdutosOutrosSistemasTableRow = {
  id: string | number;
  outroSistema: string;
  codigoProduto: string;
  nomeProduto: string;
  [key: string]: any;
};

export const headersOutrosSistemas: CustomTableHeader<ProdutosOutrosSistemasTableRow>[] =
  [
    { text: 'ID', width: 2, key: 'id', fieldType: 'number' },
    {
      text: 'Sistema',
      width: 4,
      key: 'outroSistema',
      fieldType: 'text',
    },
    { text: 'Código', width: 10, key: 'codigoProduto', fieldType: 'text' },
    {
      text: 'Nome do Produto',
      width: 60,
      key: 'nomeProduto',
      fieldType: 'text',
    },
  ];

export const fieldObjectProdutosDaf = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];

export const headersCIDs = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Tipo CID', width: 8, key: 'cid' },
  { text: 'CID', width: 8, key: 'cid' },
  { text: 'Descrição', width: 80, key: 'descricao' },
];

export const valoresExibidosOffCanvasCIDs: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorPontuacao: '',
  separadorIdentificacao: '',
  separadorFuncionalidade: '',
  separadorObservacoes: '',

  //Específicos
  interfaceSisAf: 'Interface',
  moduloSisAf: 'Módulo',
  tipoTask: 'Tipo de Task',
  responsavel: 'Responsável',
  dataEntrada: 'Data de Início',
  dataFinalizacao: 'Data Finalização',
  diasDev: 'Total de dias',
  funcionalidade: 'Funcionalidade',
  descricao: 'Descrição',
  complexidade: 'Complexidade',
  reaproveitamentoCodigo: 'Reaprov. Código',
  pontosFuncionalidade: 'Level (0 a 100)',
  statusDesenvolvimento: 'Status Dev',
  level: 'Level',
};

export type ProdutosIncorporacoesTableRow = {
  id: string | number;
  statusIncorporacao: string;
  statusPactuacao: string;
  statusAtualizacao: string;
  dataIncorporacao: string;
  diretrizClinica: string;
  [key: string]: any;
};

export const renderStatusIncorporacao = (value: unknown) => (
  <StatusIncorporacaoCell value={String(value)} />
);

export const headersIncorporacoes: CustomTableHeader<ProdutosIncorporacoesTableRow>[] =
  [
    { text: 'ID', width: 2, key: 'id', fieldType: 'number' },
    {
      text: 'St Incorporação',
      width: 8,
      key: 'statusIncorporacao',
      renderCell: (value) => renderStatusIncorporacao(value),
      fieldType: 'select',
    },
    {
      text: 'St Pactuação',
      width: 8,
      key: 'statusPactuacao',
      renderCell: (value) => renderStatusIncorporacao(value),
      fieldType: 'select',
    },
    {
      text: 'St Atualização',
      width: 8,
      key: 'statusAtualizacao',
      renderCell: (value) => renderStatusIncorporacao(value),
      fieldType: 'select',
    },
    {
      text: 'Data da incorp.',
      width: 10,
      key: 'dataIncorporacao',
      fieldType: 'date',
    },
    {
      text: 'Diretriz Clínica',
      width: 40,
      key: 'diretrizClinica',
      fieldType: 'text',
    },
  ];

export const headersIncoporacao = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status Incorp.', width: 5, key: 'statusIncorporacao' },
  { text: 'Status Pact.', width: 5, key: 'statusPactuacao' },
  { text: 'Status Atualiz.', width: 5, key: 'statusAtualizacao' },
  { text: 'Data Incorp.', width: 5, key: 'dataIncorporacao' },
  { text: 'Portaria Incorp.', width: 7, key: 'portariaIncorporacao' },
  { text: 'Data Pact.', width: 5, key: 'dataPactuacao' },
  { text: 'Ata Pact.', width: 5, key: 'ataPactuacao' },
  { text: 'Componente AF', width: 7, key: 'componentePactuado' },
];
